import _isEmpty from "lodash/isEmpty";
export type ValueOf<T> = T[keyof T];
export type PartialPick<T, K extends keyof T> = Partial<Pick<T, K>>;
export type PartialBy<T, K extends keyof T> = Omit<T, K> & PartialPick<T, K>;

export type Empty<T> = Partial<Record<keyof T, never>>;
/**
 * MaybeEmpty<T>: Type is either T or an empty object
 */
export type MaybeEmpty<T> = T | Empty<T>;
export type NotEmpty<T> = T & Exclude<T, Empty<T>>;

export const isEmpty = <T>(m: MaybeEmpty<T>): m is Empty<T> => _isEmpty(m);
export const isNotEmpty = <T>(m: MaybeEmpty<T>): m is NotEmpty<T> => !_isEmpty(m);

export type UnmappedThirdPartyValue<T extends string = ""> = `unmapped third party value for ${T}`;

// oxlint-disable-next-line typescript/ban-types
export type DeepPartial<T> = T extends Function
    ? T
    : T extends Array<infer InferredArrayMember>
      ? DeepPartialArray<InferredArrayMember>
      : T extends object
        ? DeepPartialObject<T>
        : T | undefined;

type DeepPartialArray<T> = Array<DeepPartial<T>>;

type DeepPartialObject<T> = {
    [K in keyof T]?: DeepPartial<T[K]>;
};

export type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] };
